import { useQuery } from "@apollo/client";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { Location } from "../../graphql/baseTypes";
import { GET_COMPANY, LIST_ALL_LOCATIONS } from "../../graphql/queries";
import { GetCompanyQuery } from "../../graphql/queries/getCompany";
import { ListAllLocationsQuery } from "../../graphql/queries/listAllLocations";
import { GetCompanyQueryVariables } from "../../graphql/types";
import { FilterProps } from "./types";

interface Props extends FilterProps<Location> {
  selectedCompany?: string | null;
  value?: string | null;
}

const LocationFilter: React.FC<Props> = ({
  onChange,
  onClear,
  selectedCompany,
  value,
}) => {
  const { data, loading } = useQuery<ListAllLocationsQuery>(
    LIST_ALL_LOCATIONS,
    {
      skip: !!selectedCompany,
      onError(error) {
        console.log(error);
      },
    }
  );

  const { data: companyQuery } = useQuery<GetCompanyQuery, GetCompanyQueryVariables>(
    GET_COMPANY,
    {
      fetchPolicy: "cache-first",
      variables: { ...(selectedCompany && { id: selectedCompany }) },
      skip: !selectedCompany,
      onError(error) {
        console.log(error);
      },
    }
  );
  const { getCompany } = companyQuery || {};
  const { locations: companyLocations } = getCompany || {};
  const { items: companyLocationItems } = companyLocations || {};
  const { listLocations: locations } = data || { listCompanys: { items: [] } };
  const { items: listLocations } = locations || {};
  const items = selectedCompany ? companyLocationItems : listLocations;

  const selected =
    React.useMemo(() => items?.find(({ id }) => value === id), [
      items,
      value,
    ]) || null;

  return (
    <Autocomplete<Location>
      id="location-filter-autocomplete"
      options={items || []}
      loading={loading}
      value={selected}
      getOptionLabel={(option) => option.name}
      onChange={(_, selection) => {
        if (selection) {
          onChange(selection.id, selection.companyId);
        } else {
          onClear();
        }
      }}
      getOptionSelected={(option, value) =>
        value && value.id ? option.id === value.id : false
      }
      style={{ width: 200 }}
      noOptionsText={"Keine Standorte gefunden"}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Standort"
          variant="outlined"
          size={"small"}
        />
      )}
    />
  );
};

export default LocationFilter;
